import Loading from './Loading';
import { ErrorContext } from '../lib/ErrorContext';
import { ChevronLeftIcon } from '@heroicons/react/24/outline/index.js';

const CallbackLoading = ({ children, error, message, renderError }) => {
    return (
        <ErrorContext.Provider value={{ errors: {}, setErrors: () => null }}>
            <div className="flex items-center justify-center">
                {!error && <Loading message={message} />}
                {!!error && (
                    <div>
                        {typeof renderError === 'function' &&
                            renderError(error)}
                        {typeof renderError !== 'function' && (
                            <div className="text-red-700">
                                {error}
                                <a
                                    href="#"
                                    className="flex items-center"
                                    onClick={ev => {
                                        ev.preventDefault();
                                        window.history.go(-1);
                                    }}
                                >
                                    <ChevronLeftIcon className="h-4 w-4 mr-1" />
                                    Go back
                                </a>
                            </div>
                        )}
                    </div>
                )}
                {children}
            </div>
        </ErrorContext.Provider>
    );
};

export default CallbackLoading;
